import React from 'react';
import { authorPropTypes } from './AuthorPropTypes';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Author.module.scss';
const Author = ({
  href,
  picture,
  title,
  name,
  role
}) => {
  if (!name) {
    return null;
  }
  const Component = href ? 'a' : 'div';
  const avatarSize = {
    width: 64,
    height: 64
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, (picture === null || picture === void 0 ? void 0 : picture.src) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.src,
      ...avatarSize
    },
    alt: picture.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }), !(picture !== null && picture !== void 0 && picture.src) && /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: styles.rootPicture
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "avatarPlaceholder",
    size: avatarSize,
    classname: styles.rootIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootDetails
  }, title && /*#__PURE__*/React.createElement("span", {
    className: styles.rootDetailsLabel
  }, title), /*#__PURE__*/React.createElement(Component, {
    href: href,
    className: styles.rootDetailsName
  }, name), role && /*#__PURE__*/React.createElement("div", {
    className: styles.rootDetailsRole
  }, role)));
};
export default Author;